import React from 'react';
import PropTypes from 'prop-types';

const ImageField = props => (
  <div className="deleter">
    {props.uploadedImage && (
      <button
        className="img-control delete"
        type="button"
        name="delete"
        title="delete-image"
        onClick={() => props.deleteUploadedPhoto(props.imageFieldNumber)}
      >
        &times;
      </button>
    )}
    <div
      className={
        props.imageLoading === props.imageFieldNumber
          ? 'loading upload-wrapper'
          : 'upload-wrapper'
      }
    >
      {/* eslint-disable jsx-a11y/label-has-for */}
      <label htmlFor={`comment-image-${props.imageFieldNumber}`}>
        {props.translations.image}
      </label>
      {/* eslint-enable jsx-a11y/label-has-for */}

      <input
        id={`comment-image-${props.imageFieldNumber}`}
        type="file"
        accept="image/*"
        name="image"
        alt="0"
        onChange={event => props.uploadImage(props.image, event)}
      />

      {props.uploadedImage && (
        <div
          className="img-preview"
          style={
            props.uploadedImage && {
              backgroundImage: `url(${props.uploadedImage.url})`,
            }
          }
        />
      )}

      {props.uploadedImage && (
        <button
          id={`rotate-button-${props.imageFieldNumber}`}
          className="img-control rotate"
          type="button"
          name="rotate"
          title="Rotate this image 90 degrees clockwise"
          onClick={() => props.rotatePhoto(props.imageFieldNumber)}
        >
          {props.translations['rotate-image']}
        </button>
      )}

      {props.uploadedImage &&
        !props.uploadedImage.cropped && (
          <button
            id={`crop-button-${props.imageFieldNumber}`}
            className="img-control crop"
            type="button"
            name="crop"
            onClick={() =>
              props.displayModal(`cropper-${props.imageFieldNumber}`)
            }
            title="Crop"
          >
            {props.translations['crop-image']}
          </button>
        )}
    </div>
  </div>
);

ImageField.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  image: PropTypes.shape({}).isRequired,
  imageLoading: PropTypes.number.isRequired,
  imageFieldNumber: PropTypes.number.isRequired,
  uploadImage: PropTypes.func.isRequired,
  displayModal: PropTypes.func.isRequired,
  uploadedImage: PropTypes.shape({
    cropped: PropTypes.bool,
    url: PropTypes.string,
  }),
  deleteUploadedPhoto: PropTypes.func,
  rotatePhoto: PropTypes.func,
};

ImageField.defaultProps = {
  uploadedImage: null,
  deleteUploadedPhoto: () => {},
  rotatePhoto: () => {},
};

export default ImageField;
